export const environment = {
  production: true,
  firebase: {
    projectId: 'online-store-8595d',
    appId: '1:161798579935:web:20bdcdb367f9c5c7f3ab6a',
    storageBucket: 'online-store-8595d.appspot.com',
    apiKey: 'AIzaSyB_KXx65iaX_L2QZcG7FwEZnlty3wlfW2o',
    authDomain: 'online-store-8595d.firebaseapp.com',
    messagingSenderId: '161798579935',
  },
};
